import AdditionalInfo from '../../../../components/AdditionalInfo'
import Details from '../../../../components/Details'

const Body: React.VFC = () => {
  return (
    <>
      <Details />
      <AdditionalInfo hideBooleans />
    </>
  )
}

export default Body
